import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Underline from '@tiptap/extension-underline';
import { LinkBubbleMenuHandler } from 'mui-tiptap';

export const richTextExtensions = [
  StarterKit.configure({
    code: false,
    codeBlock: false,
    blockquote: false,
    horizontalRule: false,
    strike: false,
    heading: { levels: [1, 2, 3] },
    // Disable built-in link and underline, as they are configured and added
    // separately below. StarterKit v3 includes them by default, so omitting
    // these flags would produce duplicate extension names.
    link: false,
    underline: false,
  }),
  Link.configure({
    openOnClick: false,
    HTMLAttributes: { target: '_blank', rel: 'noopener noreferrer' },
  }),
  Underline.configure({
    HTMLAttributes: { class: null },
  }),
  LinkBubbleMenuHandler,
];
